import React from 'react';
import styled from 'styled-components';

const ErrorText = styled.p`
  color: red;
`;

const ErrorMessage = ({ message }) => {
  return message ? <ErrorText>{message}</ErrorText> : null;
};

export default ErrorMessage;
